<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="addCFRequestFilteringModal" tabindex="-1" role="dialog"
         aria-labelledby="addCFRequestFilteringModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Add CF Request Filtering</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">Email</label>
                  <input v-model="email" class="form-control" placeholder="Enter email" type="text">
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-end">
                <button @click="fetchPlans" :disabled="!email || loading === 'planLoading'"
                        class="btn btn-sm btn-primary">
                  <div v-if="loading === 'planLoading'" class="loader small_loader"></div>
                  <span v-else>Fetch Plans</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <perfect-scrollbar class="scroll-area">
                  <div v-for="(row, index) in modifyAccounts" :key="index" class="col-md-12">
                    <div class="form-group">
                      <label class="make-cursor-pointer d-flex align-items-center mb-0" for="">
                        <input v-model="row.selected" @change="toggleCategory(row)" type="checkbox" class="mr-5"/>
                        <span data-toggle="collapse" :href="`#domain_${index}`" aria-expanded="false"
                              aria-controls="multiCollapseExample1">{{ row.hbHostname }}</span>
                      </label>
                    </div>
                    <div v-for="el in row.domains" :key="`${el.domain}_${index}`" :id="`domain_${index}`"
                         :class="{'show': index === 0}" class="form-group ml-30 collapse multi-collapse">
                      <label class="d-flex align-items-center mb-0" for="">
                        <input v-model="selectedDomains" :value="el" type="checkbox" class="mr-5"/>
                        {{ el.domain }}
                      </label>
                    </div>
                  </div>
                </perfect-scrollbar>
              </div>
            </div>
            <div v-if="modifyAccounts.length" class="row">
              <div class="col-md-12 d-flex justify-content-end">
                <button :disabled="loading === 'cfRequestFilteringLoader'" @click="addCfRequestFiltering" class="btn btn-sm btn-primary">
                  <div v-if="loading === 'cfRequestFilteringLoader'" class="loader small_loader"></div>
                  <span v-else>Add CF Request Filtering</span>
                </button>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-dark">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {db} from "@/firebase/init";

export default {
  name: 'AddCFFilteringModal',
  components: {PerfectScrollbar},
  data() {
    return {
      loading: null,
      email: '',
      accounts: [],
      selectedDomains: []
    }
  },
  computed: {
    modifyAccounts() {
      const array = [];
      for (const row of this.accounts) {
        const obj = {
          hbHostname: row.primary.hbHostname,
          selected: false,
          domains: [{
            domain: row.primary.domain,
            cloudflare: row.primary.cloudflare,
            hbHostname: row.primary.hbHostname
          }]
        }
        for (const addon of row.addon) {
          obj.domains.push({domain: addon.domain, cloudflare: addon.cloudflare, hbHostname: row.primary.hbHostname});
        }
        array.push(obj)
      }
      return array;
    }
  },
  methods: {
    async addCfRequestFiltering() {
      try {
        this.loading = 'addCFRequestFilteringLoading';
        const array = [];
        for (const row of this.selectedDomains) {
          const obj = array.find(el => el.hbHostname === row.hbHostname);
          if (obj) {
            obj.domains.push(row.domain);
          } else {
            array.push({hbHostname: row.hbHostname, domains: [row.domain]})
          }
        }
        console.log('array final', array)
        const resp = await this.$http.post('/bigscoots/add-cf', {
          hash: '1a18fefe16e4ab6ae1967a2ad980f396',
          plan: 'custom',
          array,
          email: this.email
        })
        console.log('resp', resp.data)
        this.showToast({message: 'You have successfully added CF request filtering for selected domains'}, true, 'success')
        $("#addCFRequestFilteringModal").modal('hide');
      } catch (e) {
        this.showToast({message: 'Something went wrong while adding CF Request Filtering to selected domains'}, true, 'danger')
      }
    },
    toggleCategory(category) {
      console.log('category', category)
      if (category.selected) {
        this.selectedDomains = [...this.selectedDomains, ...category.domains]
      } else {
        this.selectedDomains = this.selectedDomains.filter(el => el.hbHostname !== category.hbHostname)
      }
    },
    async fetchPlans() {
      try {
        this.accounts = []
        this.loading = 'planLoading'
        const ref = await db.collection('users').where('email', '==', this.email).get();
        console.log('found user', ref.size)
        if (ref.size) {
          const hostingAccountRef = await db.collection('hostingAccounts').doc(ref.docs[0].id).get();
          console.log('ref for hostingAccount', hostingAccountRef.exists);
          if (hostingAccountRef.exists) {
            const {accounts} = hostingAccountRef.data()
            this.accounts = accounts
          }
        }
      } catch (e) {
        this.showToast({message: e.toString(), duration: 0}, true, 'danger')
      } finally {
        this.loading = ''
      }
    },
    load() {
      this.accounts = []
      this.email = ''
      $("#addCFRequestFilteringModal").modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    }
  }
}
</script>

<style scoped>
.scroll-area {
  position: relative;
  max-height: 400px;
  overflow: hidden;
}
</style>